import script from "./dev-mode-select.vue?vue&type=script&setup=true&lang=js"
export * from "./dev-mode-select.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__